module.exports = __webpack_public_path__ + "two-covers-one-print-one-cactus.jpg";